import styled from "@emotion/styled";

export const BoxRightAlignament = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
